"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutboundContainerFitClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
class OutboundContainerFitClient extends base_client_1.ApiBasicAuthClient {
    constructor(config = {
        baseURL: `${process.env.OUTBOUND_CONTAINER_FIT_SERVICE_URL}`,
        basicAuthUser: process.env.OUTBOUND_CONTAINER_FIT_BASIC_AUTH_USER,
        basicAuthPassword: process.env.OUTBOUND_CONTAINER_FIT_BASIC_AUTH_PASSWORD,
        timeout: process.env.OUTBOUND_CONTAINER_FIT_TIMEOUT_MS
            ? parseInt(process.env.OUTBOUND_CONTAINER_FIT_TIMEOUT_MS, 10)
            : 13000,
    }) {
        super(config);
        if (!config.baseURL) {
            commons_logs_1.log.warn("OUTBOUND_CONTAINER_FIT_SERVICE_URL environment variable is not set");
        }
        if (!config.basicAuthUser || !config.basicAuthPassword) {
            commons_logs_1.log.warn("OUTBOUND_CONTAINER_FIT_BASIC_AUTH_USER and OUTBOUND_CONTAINER_FIT_BASIC_AUTH_PASSWORD environment variable is not set");
        }
    }
    async getFitContainers(orderId, containers, items) {
        if (containers.length === 0) {
            const emptyList = [];
            return {
                containers: emptyList,
                itemDimensionsByContainer: {},
                orderId,
            };
        }
        return this.post("v1/container", { orderId, containers, items });
    }
    async getContainerFitSolutionsV2(orderId, containers, items) {
        if (containers.length === 0) {
            const emptyList = [];
            return {
                fitSolutions: emptyList,
                orderId,
            };
        }
        return this.post("v2/container/fit-items", { orderId, containers, items });
    }
    async getContainerFitSolutionsV3(orderId, containers, items) {
        if (containers.length === 0) {
            const emptyList = [];
            return {
                fitSolutions: emptyList,
                orderId,
            };
        }
        return this.post("v3/container/fit-items", { orderId, containers, items });
    }
}
exports.OutboundContainerFitClient = OutboundContainerFitClient;
exports.default = OutboundContainerFitClient;
//# sourceMappingURL=OutboundContainerFitClient.js.map